<template functional>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <span>
      Copyright @ {{ new Date().getFullYear() }}
      <a
        href="https://urblock.co"
        target="_blank"
        rel="nofollow"
      >Urblock</a>, Todos los derechos
      reservados.
    </span>
    <span class="md:flex hidden items-center">
      <span>Hecho con</span>
      <feather-icon icon="HeartIcon" svg-classes="stroke-current text-danger w-6 h-6" class="mx-2" />
      <span>
        por
        <a href="https://davidpiiedra.com">D</a>
      </span>
    </span>
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
  props: {
    classes: {
      type: String
    }
  }
};
</script>
